import { CMS } from "../../components/cms/cms";
import { Show, onMount } from "solid-js";
import { createStore } from "solid-js/store";
import { loadAds, loadCms, setPageTitle, setSubMenu } from "../../app";
import { ISearchInstance, SearchArtworks, SearchFilter } from "../../components/search-artworks";

type State = {
    isContentReady: boolean;
}

export function HomeSearchPage() {
    let searchInstance: ISearchInstance; 
    const [state, setState] = createStore<State>({ isContentReady: false });
    const [filter, setFilter] = createStore<SearchFilter>({
        FirstName: "",
        LastName: "",
        Title: "",
        Medium: "",
        Order: "ByArtist",
        Direction: "Ascending"
    } as SearchFilter);
    const searchClicked = (e: Event) => {
        e.preventDefault();
        searchInstance.search(filter);
    };
    const clearClicked = (e: Event) => {
        e.preventDefault();
        setFilter({
            FirstName: "",
            LastName: "",
            Title: "",
            Medium: ""
        } as SearchFilter);
        searchInstance.clear();
    };
    const onSubmit = async (e: Event) => {
        e.preventDefault();
        await searchInstance.search(filter);
    };
    onMount(async () => {
        const ids = [
            "7th-arc-salon/introduction::page-body",
            "7th-arc-salon/search::page-title"
        ];
        await loadCms(ids);
        await loadAds("7th-arc-salon/live-exhibition");
        setSubMenu("Search");
        setPageTitle({ id: "7th-arc-salon/search::page-title", text: "Search" });
        setState({ isContentReady: true });
    });
    return (
        <>
            <Show when={state.isContentReady}>
                <section class="search" style="padding-top: 0; position: relative; top: 15px;">
                    <form onSubmit={onSubmit}>
                        <div class="row">
                            <div class="col-md-6 col-sm-12">
                                <div class="row">
                                    <div class="col-md-6">
                                        <h4 style="font-family: 'Oswald'; font-size: 2em;">
                                            <CMS id="form::artist" text>Artist</CMS>
                                        </h4>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <label>
                                                    <CMS id="form::first-name" text>First name</CMS>
                                                </label>
                                                <input type="text" value={filter.FirstName} onInput={(e) => setFilter("FirstName", e.currentTarget.value)} class="form-control" />
                                            </div>
                                            <div class="col-md-6">
                                                <label>
                                                    <CMS id="form::last-name" text>Last name</CMS>
                                                </label>
                                                <input type="text" value={filter.LastName} onInput={(e) => setFilter("LastName", e.currentTarget.value)} class="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <h4 style="font-family: 'Oswald'; font-size: 2em;">
                                            <CMS id="form::artwork" text>Artwork</CMS>
                                        </h4>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <label>
                                                    <CMS id="form::title" text>Title</CMS>
                                                </label>
                                                <input type="text" value={filter.Title} onInput={(e) => setFilter("Title", e.currentTarget.value)} class="form-control" />
                                            </div>
                                            <div class="col-md-6">
                                                <label>
                                                    <CMS id="form::medium" text>Medium</CMS>
                                                </label>
                                                <input type="text" value={filter.Medium} onInput={(e) => setFilter("Medium", e.currentTarget.value)} class="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" style="margin-top: 10px;">
                            <div class="col-md-4">
                                <button type="submit" onClick={searchClicked} class="btn btn-success">
                                    <CMS text id="button::search">Search</CMS>
                                </button>
                                <button type="button" onClick={clearClicked} style="margin-left: 10px;" class="btn btn-default">
                                    <CMS text id="button::clear">Clear</CMS>
                                </button>
                            </div>
                        </div>
                    </form>
                </section>
                <div style="margin-top: 40px;">
                    <SearchArtworks filter={filter} settings={{ ShowArtist: true }} setInstance={(instance) => searchInstance = instance } />
                </div>
            </Show>
        </>
    )
}